var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "c-spinner",
      class: {
        "c-spinner--disabled": _vm.disabled,
        "c-spinner--large": _vm.large
      }
    },
    [
      _c(
        "span",
        {
          staticClass: "c-spinner__button c-spinner__button--down",
          on: {
            click: function($event) {
              return _vm.decreaseNumber()
            }
          }
        },
        [
          _vm.showDelete
            ? _c(
                "svg",
                {
                  attrs: {
                    "aria-hidden": "true",
                    focusable: "false",
                    "data-prefix": "fas",
                    "data-icon": "trash",
                    role: "img",
                    xmlns: "http://www.w3.org/2000/svg",
                    viewBox: "0 0 448 512"
                  }
                },
                [
                  _c("path", {
                    attrs: {
                      fill: "currentColor",
                      d:
                        "M432 32H312l-9.4-18.7A24 24 0 0 0 281.1 0H166.8a23.72 23.72 0 0 0-21.4 13.3L136 32H16A16 16 0 0 0 0 48v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16zM53.2 467a48 48 0 0 0 47.9 45h245.8a48 48 0 0 0 47.9-45L416 128H32z"
                    }
                  })
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          !_vm.showDelete
            ? _c(
                "svg",
                {
                  attrs: {
                    width: "12px",
                    height: "2px",
                    viewBox: "0 0 12 2",
                    version: "1.1",
                    xmlns: "http://www.w3.org/2000/svg",
                    "xmlns:xlink": "http://www.w3.org/1999/xlink"
                  }
                },
                [
                  _c(
                    "g",
                    {
                      attrs: {
                        id: "Desktop",
                        stroke: "none",
                        "stroke-width": "1",
                        fill: "none",
                        "fill-rule": "evenodd"
                      }
                    },
                    [
                      _c(
                        "g",
                        {
                          attrs: {
                            id: "SlideinBasket",
                            transform: "translate(-1201.000000, -312.000000)",
                            fill: "#666666",
                            "fill-rule": "nonzero"
                          }
                        },
                        [
                          _c(
                            "g",
                            {
                              attrs: {
                                id: "Minus",
                                transform: "translate(1201.000000, 312.000000)"
                              }
                            },
                            [
                              _c("rect", {
                                attrs: {
                                  id: "Rectangle",
                                  x: "0",
                                  y: "0",
                                  width: "12",
                                  height: "2",
                                  rx: "1"
                                }
                              })
                            ]
                          )
                        ]
                      )
                    ]
                  )
                ]
              )
            : _vm._e()
        ]
      ),
      _vm._v(" "),
      _c("input", {
        staticClass: "c-spinner__input",
        attrs: { type: "text", min: _vm.min },
        domProps: { value: _vm.numericValue },
        on: { keypress: _vm.validateInput, input: _vm.inputValue }
      }),
      _vm._v(" "),
      _c(
        "span",
        {
          staticClass: "c-spinner__button c-spinner__button--up",
          on: {
            click: function($event) {
              return _vm.increaseNumber()
            }
          }
        },
        [
          _c(
            "svg",
            {
              attrs: {
                width: "12px",
                height: "12px",
                viewBox: "0 0 12 12",
                version: "1.1",
                xmlns: "http://www.w3.org/2000/svg",
                "xmlns:xlink": "http://www.w3.org/1999/xlink"
              }
            },
            [
              _c(
                "g",
                {
                  attrs: {
                    id: "Desktop",
                    stroke: "none",
                    "stroke-width": "1",
                    fill: "none",
                    "fill-rule": "evenodd"
                  }
                },
                [
                  _c(
                    "g",
                    {
                      attrs: {
                        id: "SlideinBasket",
                        transform: "translate(-1301.000000, -307.000000)",
                        fill: "#666666",
                        "fill-rule": "nonzero"
                      }
                    },
                    [
                      _c(
                        "g",
                        {
                          attrs: {
                            id: "Plus",
                            transform: "translate(1301.000000, 307.000000)"
                          }
                        },
                        [
                          _c("path", {
                            attrs: {
                              d:
                                "M6,0 C6.55228475,-1.01453063e-16 7,0.44771525 7,1 L7,5 L11,5 C11.5522847,5 12,5.44771525 12,6 C12,6.55228475 11.5522847,7 11,7 L7,7 L7,11 C7,11.5522847 6.55228475,12 6,12 C5.44771525,12 5,11.5522847 5,11 L5,7 L1,7 C0.44771525,7 6.76353751e-17,6.55228475 0,6 C-6.76353751e-17,5.44771525 0.44771525,5 1,5 L5,5 L5,1 C5,0.44771525 5.44771525,1.01453063e-16 6,0 Z",
                              id: "Combined-Shape"
                            }
                          })
                        ]
                      )
                    ]
                  )
                ]
              )
            ]
          )
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }